import React from 'react';
import { SVGProps } from 'react';

const DOCIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#clip0_7_1421)">
            <path
                d="M37.2279 74.4558C57.7873 74.4558 74.454 57.7891 74.454 37.2296C74.454 16.6702 57.7873 0.00344849 37.2279 0.00344849C16.6684 0.00344849 0.00170898 16.6702 0.00170898 37.2296C0.00170898 57.7891 16.6684 74.4558 37.2279 74.4558Z"
                fill="#FAFAFA"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.6081 63.6448C6.60905 66.9604 9.29998 69.6476 12.613 69.6456L49.0603 69.624L49.0491 30.8056L12.535 30.8273C9.25822 30.8292 6.59942 33.4911 6.60036 36.7675L6.6081 63.6448Z"
                fill="#0062FF"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.63006 35.0577C8.63077 37.5303 10.6382 39.5363 13.1105 39.5348L48.407 39.5139L48.4047 31.4468L12.2167 31.4683C10.2367 31.4695 8.62949 33.0779 8.63006 35.0577Z"
                fill="#014BC3"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M53.3883 4.80797L64.2228 15.6425V67.9193H13.5713V4.80797H53.3883Z"
                fill="white"
                stroke="#ABABAB"
                strokeWidth="0.348873"
                strokeMiterlimit="1"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M53.3884 4.80834L64.2225 15.6429H53.3884V4.80834Z"
                fill="#ABABAB"
            />
            <rect
                x="17.4856"
                y="27.8571"
                width="42.8571"
                height="5.01429"
                rx="2.50714"
                fill="#0062FF"
                fillOpacity="0.65"
            />
            <rect
                x="17.4856"
                y="35.4214"
                width="42.8571"
                height="5.01429"
                rx="2.50714"
                fill="#0062FF"
                fillOpacity="0.4"
            />
            <rect x="17.4856" y="19.9928" width="32.1429" height="5.01429" rx="2.50714" fill="#0062FF" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M67.6317 47.0898C67.6317 42.9388 64.2618 39.5688 60.1101 39.5688H13.1785V69.6527H60.1101C64.2618 69.6527 67.6317 66.2828 67.6317 62.1318V47.0898Z"
                fill="#0062FF"
            />
            <path
                d="M25.9557 61H21.8307V49.3636H25.9898C27.1602 49.3636 28.1678 49.5966 29.0125 50.0625C29.8572 50.5246 30.5068 51.1894 30.9614 52.0568C31.4197 52.9242 31.6489 53.9621 31.6489 55.1705C31.6489 56.3826 31.4197 57.4242 30.9614 58.2955C30.5068 59.1667 29.8534 59.8352 29.0012 60.3011C28.1527 60.767 27.1375 61 25.9557 61ZM24.2909 58.892H25.8534C26.5807 58.892 27.1924 58.7633 27.6887 58.5057C28.1887 58.2443 28.5637 57.8409 28.8137 57.2955C29.0674 56.7462 29.1943 56.0379 29.1943 55.1705C29.1943 54.3106 29.0674 53.608 28.8137 53.0625C28.5637 52.517 28.1905 52.1155 27.6943 51.858C27.1981 51.6004 26.5864 51.4716 25.8591 51.4716H24.2909V58.892ZM44.1645 55.1818C44.1645 56.4508 43.924 57.5303 43.4429 58.4205C42.9656 59.3106 42.3141 59.9905 41.4884 60.4602C40.6664 60.9261 39.7422 61.1591 38.7156 61.1591C37.6816 61.1591 36.7535 60.9242 35.9316 60.4545C35.1096 59.9849 34.46 59.3049 33.9827 58.4148C33.5054 57.5246 33.2668 56.447 33.2668 55.1818C33.2668 53.9129 33.5054 52.8333 33.9827 51.9432C34.46 51.053 35.1096 50.375 35.9316 49.9091C36.7535 49.4394 37.6816 49.2045 38.7156 49.2045C39.7422 49.2045 40.6664 49.4394 41.4884 49.9091C42.3141 50.375 42.9656 51.053 43.4429 51.9432C43.924 52.8333 44.1645 53.9129 44.1645 55.1818ZM41.6702 55.1818C41.6702 54.3599 41.5471 53.6667 41.3009 53.1023C41.0584 52.5379 40.7156 52.1099 40.2725 51.8182C39.8293 51.5265 39.3103 51.3807 38.7156 51.3807C38.1209 51.3807 37.602 51.5265 37.1588 51.8182C36.7156 52.1099 36.3709 52.5379 36.1247 53.1023C35.8823 53.6667 35.7611 54.3599 35.7611 55.1818C35.7611 56.0038 35.8823 56.697 36.1247 57.2614C36.3709 57.8258 36.7156 58.2538 37.1588 58.5455C37.602 58.8371 38.1209 58.983 38.7156 58.983C39.3103 58.983 39.8293 58.8371 40.2725 58.5455C40.7156 58.2538 41.0584 57.8258 41.3009 57.2614C41.5471 56.697 41.6702 56.0038 41.6702 55.1818ZM56.254 53.4375H53.7654C53.7199 53.1155 53.6271 52.8295 53.4869 52.5795C53.3468 52.3258 53.1669 52.1099 52.9472 51.9318C52.7275 51.7538 52.4737 51.6174 52.1858 51.5227C51.9017 51.428 51.593 51.3807 51.2597 51.3807C50.6574 51.3807 50.1328 51.5303 49.6858 51.8295C49.2388 52.125 48.8923 52.5568 48.646 53.125C48.3998 53.6894 48.2767 54.375 48.2767 55.1818C48.2767 56.0114 48.3998 56.7083 48.646 57.2727C48.896 57.8371 49.2445 58.2633 49.6915 58.5511C50.1385 58.839 50.6555 58.983 51.2426 58.983C51.5722 58.983 51.8771 58.9394 52.1574 58.8523C52.4415 58.7652 52.6934 58.6383 52.9131 58.4716C53.1328 58.3011 53.3146 58.0947 53.4585 57.8523C53.6063 57.6099 53.7085 57.3333 53.7654 57.0227L56.254 57.0341C56.1896 57.5682 56.0286 58.0833 55.771 58.5795C55.5173 59.072 55.1744 59.5133 54.7426 59.9034C54.3146 60.2898 53.8032 60.5966 53.2085 60.8239C52.6176 61.0474 51.9491 61.1591 51.2029 61.1591C50.165 61.1591 49.2369 60.9242 48.4188 60.4545C47.6044 59.9849 46.9604 59.3049 46.4869 58.4148C46.0173 57.5246 45.7824 56.447 45.7824 55.1818C45.7824 53.9129 46.021 52.8333 46.4983 51.9432C46.9756 51.053 47.6233 50.375 48.4415 49.9091C49.2597 49.4394 50.1801 49.2045 51.2029 49.2045C51.8771 49.2045 52.5021 49.2992 53.0779 49.4886C53.6574 49.678 54.1707 49.9545 54.6176 50.3182C55.0646 50.678 55.4282 51.1193 55.7085 51.642C55.9926 52.1648 56.1744 52.7633 56.254 53.4375Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_7_1421">
                <rect width="75" height="75" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default DOCIcon;
